import { bindActionCreators as bindActions } from "redux";
import { connect } from "react-redux";
//
import Distance from "../components/Distance";

// @connect
import * as ajax from "../modules/ajax";
import * as auth from "../modules/auth";
import { getModel, getModelDistance } from "../selectors";

const state = (state, props) => {
  const { booking, auth } = state;
  const model = getModel(state, props.modelId);

  // Area
  let area = null;

  if (!booking.outcall && model.location) {
    area = model.location.area;
  }

  // Distance
  const distance = getModelDistance(state, model.id);

  return {
    isPending: auth.lat !== null,
    isModelLocated: model.lat !== null,
    area,
    distance,
  };
};

const actions = (dispatch) =>
  bindActions(
    {
      startLoading: ajax.ajaxPendingAction,
      stopLoading: ajax.ajaxSuccessAction,
      setError: ajax.ajaxErrorAction,
      setUserLocation: auth.setUserLocationAction,
    },
    dispatch
  );

export default connect(
  state,
  actions
)(Distance);
